import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-orm';
import { APCustomText } from './../builders/custom_text_builder';
import { IAPCustomTextDatasource } from './../datasources/custom_text_datasource';
export class APCustomTextQuery implements IQuery {
  private __result: Record<APCustomText['nk'], APCustomText>;

  constructor(private ngAPCustomTextDatasource: IAPCustomTextDatasource) {
    ORMMediator.registerQuery(this, ngAPCustomTextDatasource);
  }

  run() {
    this.__result = _4.keyBy(this.ngAPCustomTextDatasource.values(), 'nk');
    return this;
  }

  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPCustomTextQuery', APCustomTextQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/custom_texts/queries/custom_text_query.ts